/**
 * Test File: Basic React Component Verification
 * Created: 2025-09-23
 * Status: Permanent
 * Dependencies: None
 * Cleanup Condition: Keep - Core functionality testing
 *
 * Basic Test Page - Minimal React component to test if app is working
 */

import React from 'react';

const BasicTest: React.FC = () => {
  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1 style={{ color: 'green' }}>✅ Basic Test Page</h1>
      <p>If you can see this, React is working!</p>
      <p>Current time: {new Date().toLocaleTimeString()}</p>

      <div style={{ marginTop: '20px' }}>
        <button
          onClick={() => alert('JavaScript is working!')}
          style={{
            padding: '10px 20px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Test JavaScript
        </button>
      </div>

      <div
        style={{
          marginTop: '20px',
          padding: '10px',
          backgroundColor: '#f8f9fa',
          border: '1px solid #dee2e6'
        }}
      >
        <h3>Navigation Links:</h3>
        <ul>
          <li>
            <a href="/">Home</a>
          </li>
          <li>
            <a href="/test/simple">Simple Test</a>
          </li>
          <li>
            <a href="/test/google-drive-real">Google Drive Test</a>
          </li>
          <li>
            <a href="/test/google-api-debug">Google API Debug</a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default BasicTest;
